<div class="card">
    <div class="card-header g-0 row" #headerElement>
        <div
            class="col-12 col-lg-auto d-flex align-items-center"
            (click)="toggleAccordion($event, headerElement)"
            [ngClass]="{ 'card-invalid': accordionInvalid }"
        >
            <fa-icon *ngIf="open" [icon]="faChevronDown" size="lg"></fa-icon>
            <fa-icon *ngIf="!open" [icon]="faChevronRight" size="lg"></fa-icon>
            <h4 class="d-none d-lg-block ps-2">
                <ng-container *ngTemplateOutlet="heading"></ng-container>
            </h4>
            <h4 class="d-block d-lg-none fs-5 ps-2">
                <ng-container *ngTemplateOutlet="heading"></ng-container>
            </h4>
        </div>
        <div class="pt-1 col-12 col-lg d-inline-flex justify-content-end">
            <div class="flex-fill flex-lg-grow-0">
                <ng-container *ngTemplateOutlet="actionButton"></ng-container>
            </div>
            <button
                class="btn btn-link"
                (click)="expandSectionWithSubsections()"
                translate="F4M_ACCORDION_EXPAND_LABEL"
            ></button>
            <button
                class="btn btn-link"
                (click)="collapseSectionWithSubsections()"
                translate="F4M_ACCORDION_COLLAPSE_LABEL"
            ></button>
        </div>
    </div>
    <div class="card-body" *ngIf="open">
        <ng-container *ngTemplateOutlet="body"></ng-container>
        <div class="close-container">
            <button class="btn btn-link" (click)="toggleAccordion($event, headerElement)">
                <ng-container *ngTemplateOutlet="closer"></ng-container>
            </button>
        </div>
    </div>
</div>
